export default "__VITE_ASSET__Cf7vOu8X__"